import React, { Component } from 'react';
import Radium from 'radium';
import { semanticColors } from '../../Globals/styles';


class StickyNoteDragPreview extends Component{
  render()  {
    return (
      <div style={[styles.dragable]}>
        <div style={styles.innerContainer}>
          <img src="/images/Drag_and_Drop.png" alt="dragNDrop" style={styles.img} />
          Sticky Note
        </div>
      </div>
    );
  }
}


var styles = {
  dragable: {
    height: '40px',
    lineHeight: '40px',
    borderRadius: '2px',
    width: '180px',
    textAlign: 'center',
    position: 'absolute',
    backgroundColor: semanticColors.warningLight,
    left: '22px',
    right: '22px',
    top: '12px',
    zIndex: '1',
    cursor:'pointer'
  },
  innerContainer:{
    position: 'relative'
  },
  img: {
    position: 'absolute',
    left: '12px',
    top: '10px'
  }
}

export default Radium(StickyNoteDragPreview)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/stickyNoteDragPreview.jsx